import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";

import { CLink } from "@appcues/component-library";

export default class EventOption extends Component {
  constructor(props) {
    super(props);

    let lastSeen = moment(props.event.lastSeenTs);

    this.eventOptionRef = null;

    this.state = {
      renderMetadata: false,
      lastSeen,
      isStale: lastSeen.diff(Date.now(), "days") < -10,
      top: 0
    };
  }

  cancelEvent = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  setEventOptionRef = element => {
    this.eventOptionRef = element;
  };

  renderMetadata = () => {
    this.setState({ renderMetadata: true });

    this.calculatePosition();
  };

  calculatePosition = () => {
    const { selectMenuRef } = this.props;

    this.setState({
      // Set the menu position so its in line with the hovered option
      top:
        this.eventOptionRef && selectMenuRef
          ? this.eventOptionRef.getBoundingClientRect().top -
            selectMenuRef.getBoundingClientRect().bottom -
            32
          : 10
    });
  };

  render() {
    const { event } = this.props;
    const { renderMetadata, lastSeen, isStale, top } = this.state;

    //only render div initially to improve rendering times
    if (!renderMetadata) {
      return (
        <div onMouseEnter={this.renderMetadata} ref={this.setEventOptionRef}>
          {event.label}
        </div>
      );
    }

    return (
      <StyledOption top={top}>
        <span ref={this.setEventOptionRef}>{event.label}</span>
        {!event.isInTree && renderMetadata && (
          <div
            className="metadata-container"
            onMouseDown={this.cancelEvent}
            onMouseUp={this.cancelEvent}
            onClick={this.cancelEvent}
          >
            <div className="metadata-card">
              <FlexRow align="start">
                <h2 className="event-label">{event.label}</h2>
                {/* we don't specify a tab in this link because Events
                is the default tab */}
                <CLink className="link manage-link" href="/events-attributes">
                  <span>Manage</span>
                  <i className="fas fa-long-arrow-alt-right" />
                </CLink>
              </FlexRow>
              {isStale && (
                <Timestamp>
                  <i className="fas fa-exclamation-triangle" />
                  <p>Last seen {lastSeen.fromNow()}</p>
                </Timestamp>
              )}
              {event.description && (
                <DataType>
                  <span className="card-label">Description: </span>
                  <span className="card-value">{event.description}</span>
                </DataType>
              )}
            </div>
          </div>
        )}
      </StyledOption>
    );
  }
}

const FlexRow = styled.div`
  display: flex;
  flex-wrap: ${props => (props.flexWrap ? "wrap" : "nowrap")};
  justify-content: ${props => props.justifyContent || "space-between"};
  align-items: ${props => props.align};
  margin-bottom: 8px;
`;

const Timestamp = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  color: ${props => props.theme["$gray-30"]};
  font-size: 14px;

  height: 24px;
  margin: -4px 0 8px 0;

  p {
    padding: 0 8px;
    margin: 0;
    font-weight: 300;
  }
`;

const DataType = styled.div`
  margin-bottom: 8px;

  .card-label {
    color: ${props => props.theme["$gray-30"]};
    padding-right: 8px;
  }

  i {
    padding-right: 8px;
  }
`;
const StyledOption = styled.div`
  width: calc(100% + 32px) !important;
  margin-right: 0 !important;
  padding-right: 16px !important;

  .metadata-container {
    display: none;
    position: absolute;
    right: 24px;
    transform: translateX(100%);
    top: ${props => props.top || 0}px;
    padding-left: 36px;
    .metadata-card {
      display: flex;
      cursor: default;
      flex-direction: column;
      justify-content: flex-start;

      width: 320px;
      margin-top: 16px;
      padding: 16px 20px;
      border-radius: 4px;
      border: 2px solid ${props => props.theme["$gray-3"]};

      background: white;
      color: ${props => props.theme["$gray-90"]};

      p {
        margin: 0;
      }

      .event-label {
        font-weight: 400;
        margin: 0 8px 0 0;
      }

      .link {
        margin: 0;
        color: ${props => props.theme["$blue"]};
        font-weight: 300;
        cursor: pointer;

        &.manage-link {
          i {
            padding-left: 4px;
          }
        }
      }
    }
  }

  &:hover .metadata-container {
    display: block;
  }
`;
